<template>
  <div v-click-outside="close" class="relative inline-block text-left">
    <div class="max-h-[29px]">
      <button
        type="button"
        :disabled="disabled"
        class="flex w-full items-center font-normal"
        data-testid="cart-quantity"
        :class="{
          'py-2 pl-2 pr-6 md:pl-4 md:pr-0': !noSpacing,
          'text-sm': !textMedium,
        }"
        @click="isDropdownVisible = !isDropdownVisible"
      >
        {{ quantity }}
        <LazyIconFielmannChevronDown
          class="my-0.5 ml-2 size-3 text-neutral-90"
          :class="{ hidden: disabled }"
        />
      </button>
    </div>
    <div
      class="absolute right-0 z-[15] w-16 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-gray-300 focus:outline-none"
      :class="{ 'hidden sm:hidden': !isDropdownVisible }"
      tabindex="-1"
    >
      <div class="py-1">
        <div
          v-for="amount in availableQuantities"
          :key="amount"
          :data-testid="`quantity-${amount}`"
          class="block cursor-pointer px-4 py-2 text-center text-gray-700 hover:bg-gray-200"
          :value="amount"
          :class="{
            'text-sm': !textMedium,
          }"
          @click="onClick(amount)"
        >
          {{ amount }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// @ts-expect-error missing type definitions
import vClickOutside from 'vue-click-outside'

const props = defineProps({
  availableQuantity: {
    type: Number as PropType<number>,
    default: undefined,
  },
  maxSelectItems: {
    type: Number as PropType<number>,
    default: 9,
  },
  quantity: {
    type: Number as PropType<number>,
    default: 1,
  },
  noSpacing: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  textMedium: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const isDropdownVisible = ref(false)

const availableQuantities = computed(() => {
  const { availableQuantity, maxSelectItems } = props
  return !availableQuantity || availableQuantity > maxSelectItems
    ? maxSelectItems
    : availableQuantity
})
const close = () => (isDropdownVisible.value = false)

const emit = defineEmits<{
  'click:change-quantity': [quantity: number]
}>()

const onClick = (amount: number) => {
  isDropdownVisible.value = !isDropdownVisible.value
  emit('click:change-quantity', amount)
}
</script>
